import React, { useEffect, useRef, useState } from "react";

import { Organization } from "chq";
import { Button, Icon, classnames } from "@culturehq/components";
import { Trans, showUnsplashImageFinder } from "app/utils";
import CameraRecorder from "components/common/CameraRecorder";
import { useIsIos, useIsLoggedIn } from "app/hooks";
import { usePostStoryContext } from "../../contexts/PostStoryContext";
import { isMediaVideoType } from "../../utils";

const PostStoryButtons = () => {
  const isLoggedIn = useIsLoggedIn();
  const isIos = useIsIos();
  const {
    organization,
    state: { selectedImages, selectedPrompt, selectedMedia },
    searchBarRef,
    setState: setPostStoryState,
    handleFilesSelected,
    handleFindOnUnsplash,
    handleMediaChange
  } = usePostStoryContext();
  const [acceptedFiles, setAcceptedFiles] = useState<string>();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const hasSummary = !!selectedPrompt?.summary;

  useEffect(() => {
    if (selectedImages.length > 0 || selectedPrompt?.allowedTypes === "just_images") {
      setAcceptedFiles("image/*");
    } else if (selectedPrompt?.allowedTypes === "just_videos") {
      setAcceptedFiles("video/*");
    } else {
      setAcceptedFiles("image/*,video/*");
    }
  }, [selectedImages.length, selectedPrompt, setAcceptedFiles]);

  const isFileOrBlob = selectedMedia instanceof File || selectedMedia instanceof Blob;
  const actionName = isLoggedIn ? "Upload" : "Add";
  const org = organization as Organization;

  const handleOpenCameraRecorder = () => setPostStoryState({ pausedVideo: true });

  return (
    <div
      className={classnames("buttons-container", {
        "buttons-container--margin": !hasSummary
      })}
    >
      <label
        className="chq-ffd user-selected-image story-media-btn"
        style={
          !showUnsplashImageFinder(org, selectedPrompt)
          && selectedPrompt?.allowedTypes === "just_images"
            ? { flex: "auto" }
            : {}
        }
      >
        <div
          className="chq-ffd--im"
          // tabIndex={0}
          onKeyDown={e => {
            if (e.key === "Enter" && fileInputRef.current) fileInputRef.current.click();
          }}
        >
          <div className="chq-ffd--im--bt-upl">
            <Icon icon="images" />{" "}
            {selectedImages.length > 0 ? (
              <Trans>{actionName} more images</Trans>
            ) : (
              <Trans>
                {actionName}{" "}
                {selectedPrompt?.allowedTypes === "just_images"
                  ? "image(s)"
                  : "media"}
              </Trans>
            )}
          </div>
          <input
            ref={fileInputRef}
            accept={acceptedFiles}
            multiple={
              !isFileOrBlob
              || (isFileOrBlob
                && typeof selectedMedia !== "string"
                && !isMediaVideoType(selectedMedia as Blob))
            }
            type="file"
            onChange={handleFilesSelected}
          />
        </div>
      </label>
      {showUnsplashImageFinder(org, selectedPrompt) && (
        <Button
          className="story-media-btn"
          onClick={() => {
            if (searchBarRef?.current) {
              // eslint-disable-next-line no-param-reassign
              searchBarRef.current.componentDidMount();
            }
            handleFindOnUnsplash(true);
          }}
        >
          <Icon icon="search" />
          <Trans>Find images</Trans>
        </Button>
      )}
      { selectedPrompt?.allowedTypes !== "just_images"
        && selectedImages.length === 0 && !isIos && (
          <CameraRecorder
            organization={org}
            className="story-media-btn"
            onVideoRecorded={handleMediaChange}
            onOpen={handleOpenCameraRecorder}
          >
            <Icon icon="video-camera-filled" />
            <Trans>Record video</Trans>
          </CameraRecorder>
        )}
    </div>
  );
};

export default PostStoryButtons;
